import AbstractModule from '../../core/AbstractModule';
import RouteBuilder from '../../core/RouteBuilder';
import addProgramComponent from './AddProgramPage.vue';
import assessmentsPage from "./ProgramsPage.vue";

class AddProgramModule extends AbstractModule {
  getRoutes(): any[] {
    let routes = new RouteBuilder()
      .path('/add-program')
      .meta('authenticated', true)
      .meta('onboarded', true)
      .component(addProgramComponent)
      .build();
    routes = routes.concat(new RouteBuilder()
      .path('/programs')
      .meta('authenticated', true)
      .meta('onboarded', true)
      .component(assessmentsPage)
      .build());
    return routes;
  }
}

new AddProgramModule();
